import * as Sentry from "@sentry/react";

interface UnderwritingResponseLike {
  underwritingReason?: string;
  underwritingReasonCode?: string;
  feedbackReason?: string;
}

/** An underwriting (UWR) rejection is a business outcome, not a crash — report it to Sentry as a
 * warning (not an exception) so we can monitor how often and why it happens. */
export const reportUnderwritingWarning = (
  source: "premium-calculation" | "recommendation" | "offer" | "application" | "coverage" | "sub-coverage",
  response: UnderwritingResponseLike,
  coverageId?: string,
  subCoverageIds?: string[]
): void => {
  const reasonCode = response.underwritingReasonCode;
  const reason = response.underwritingReason || response.feedbackReason;
  Sentry.captureMessage(`Underwriting declined (${source}${coverageId ? `: ${coverageId}` : ""})`, {
    level: "warning",
    tags: { underwriting: "declined", underwriting_source: source, ...(coverageId ? { underwriting_coverage: coverageId } : {}), ...(reasonCode ? { underwriting_reason_code: reasonCode } : {}) },
    extra: { reason, reasonCode, coverageId, subCoverageIds },
    fingerprint: ["underwriting-declined", source, coverageId ?? "", ...(subCoverageIds ?? []), reasonCode ?? reason ?? "unknown"],
  });
};
